/** @jsx jsx */
import { jsx, Box, Flex, Grid } from "theme-ui";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { PageContentNonMemoized } from "gatsby-plugin-hfn-profile/components/PageContentNonMemoized";
import { eventCallbackTriggers } from "../../templates/wppage";
import HFNlogo from "../../../static/imgs/donations-logo.png";
import Seo from "../../components/seo";
import Auth from "../../components/Auth";

const corpusFundPageContent = (id, modalTitle) => {
  const titletext = modalTitle || "Donation for Corpus Fund";
  return `<gatsby_donation donationId = "${id}" btntext = "${titletext}" btnBg = #4d8f15 colortext = black colorprimary = forestgreen colorsecondary = darkgreen colorbackground = white colormuted = #f6f6f6 colorhighlight = #efeffe titletext = "Donation for Corpus Fund" allowOverseas = false/>`;
};

const generalFundPageContent = (id, modalTitle) => {
  const titletext = modalTitle || "Heartfulness General Fund";
  return `<gatsby_donation donationId="${id}" btntext="${titletext}"
  btnBg=#4d8f15 colortext = navy colorprimary = #085788
  colorsecondary = midnightblue colorbackground = white
  colormuted = #f6f6f6 colorhighlight = #efeffe titletext =
  "Heartfulness General Fund" />`;
};

const kanhaBuildingPageContent = (id, modalTitle) => {
  const titletext = modalTitle || "Donation for Green Kanha";
  return `<gatsby_donation donationId = "${id}" btntext = "${titletext}"  btnBg = #4d8f15 colortext = black colorprimary = forestgreen colorsecondary = darkgreen colorbackground = white colormuted = #f6f6f6 colorhighlight = #efeffe titletext = " Donation for Kanha Building" allowOverseas = false/>`;
};
const PageContent = React.memo(PageContentNonMemoized);

const SmsfIndiaDonation = () => {
  const headerRef = useRef();

  const [applySticky, setApplySticky] = useState(false);

  const handleHeaderSticky = () => {
    if (headerRef.current && window.pageYOffset > headerRef.current.offsetTop)
      setApplySticky(true);
    else setApplySticky(false);
  };

  useEffect(
    () => window.addEventListener("scroll", handleHeaderSticky),
    [applySticky]
  );

  const eventCallback = useCallback(
    (event) => eventCallbackTriggers("Donation_for_smsf_india_donation", event),
    []
  );

  // Auth imported
  return (
    <>
      <Auth />
      <Seo title="SMSF India Donations" />
      <div>
        <Grid
          sx={{
            fontWeight: "300",
          }}
        >
          <Box>
            <div
              sx={{
                padding: "35px 0px",
                backgroundColor: "#dff2f6",
                border: "1px solid #d3d5d2",
                marginBottom: "30px",
              }}
            >
              <div className="container">
                <h2
                  className="text-center"
                  sx={{
                    fontSize: "24px ",
                    fontWeight: "300",
                    color: "#43679c",
                  }}
                >
                  Sahaj Marg Spirituality Foundation, India - Donations
                </h2>
              </div>
            </div>
          </Box>
          <Box
            sx={{
              paddingRight: "35px",
              paddingLeft: "35px",
              fontSize: "17px ",
            }}
          >
            <Flex
              sx={{
                flexDirection: ["column", null, null, "row", null],
              }}
            >
              <Box sx={{ flex: ["2", null, null, "2", null] }}>
                <p sx={{ lineHeight: "34px" }}>
                  <b>Welcome!</b> Thank you for choosing to donate to Sahaj Marg
                  Spirituality Foundation, India.
                </p>
                <p>
                  Sahaj Marg Spirituality Foundation supports all the events and
                  programs undertaken by <b>Hearfulness</b>.
                </p>
              </Box>
              <Box sx={{ flex: ["1", null, null, "1", null] }}>
                <img src={HFNlogo} alt="hfnlogo" width="300px" />
              </Box>
            </Flex>

            <p sx={{ lineHeight: "34px" }}>
              On completion of the donation, a confirmation email will be sent
              to you with a completed donation form attached.{" "}
              <b>
                {" "}
                Please forward this mail back to{" "}
                <a
                  href="mailto:info.accounts@sahajmarg.org"
                  sx={{ color: "#4b77a1", textDecoration: "none" }}
                >
                  {" "}
                  info.accounts@sahajmarg.org{" "}
                </a>{" "}
                along with its attachment, as your confirmation of the donation.
              </b>
            </p>
            <p>
              <b>There are no refunds for donations.</b>
            </p>
            <div
              sx={{
                color: "#31708f",
                backgroundColor: "#d9edf7",
                borderColor: "#bce8f1",
                padding: "15px 15px 2px 15px",
                marginBottom: "20px",
                border: "1px solid transparent",
                borderRadius: "4px",
              }}
            >
              <p sx={{}}>Please select one of the following funds.</p>
            </div>

            <Box
              className="donation-container"
              sx={{
                border: "1px solid #ddd",
                marginBottom: "35px",
              }}
            >
              <Box
                sx={{
                  borderBottom: "1px solid #ddd",
                  padding: "8px",
                }}
              >
                <b>Donation for SMSF India - Corpus Fund</b>
                <br />
                <span>
                  Donation to Corpus Fund would form a part of the capital of
                  the Organization.
                </span>
                <div
                  className="donation-btn"
                  sx={{
                    display: "flex",
                  }}
                >
                  <PageContent
                    eventCallback={eventCallback}
                    pageContent={corpusFundPageContent(1, "Contribute Now")}
                  />
                </div>
              </Box>

              <Box
                sx={{
                  borderBottom: "1px solid #ddd",
                  padding: "8px",
                }}
              >
                <b>Donation for SMSF India - General Fund</b>
                <br />
                <span>
                  Donation to General Fund would be used for the objectives of
                  the Organization and Heartfulness.
                </span>
                <div
                  sx={{
                    display: "flex",
                  }}
                >
                  <PageContent
                    eventCallback={eventCallback}
                    pageContent={generalFundPageContent(2, "Contribute Now")}
                  />
                </div>
              </Box>

              <Box
                sx={{
                  padding: "8px",
                }}
              >
                <b>Donation for SMSF India - Kanha Building Fund</b>
                <br />
                <span>
                  Donation to this fund would be used specifically for the
                  construction works at Kanha, Hyderabad.
                </span>
                <div
                  sx={{
                    display: "flex",
                  }}
                >
                  <PageContent
                    eventCallback={eventCallback}
                    pageContent={kanhaBuildingPageContent(3, "Contribute Now")}
                  />
                </div>
              </Box>
            </Box>
          </Box>
        </Grid>
      </div>
    </>
  );
};

export default SmsfIndiaDonation;
